import { render, staticRenderFns } from "./AmortizationBooks.vue?vue&type=template&id=778985a4&"
import script from "./AmortizationBooks.vue?vue&type=script&lang=js&"
export * from "./AmortizationBooks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports